import { stringToBytes_SJIS } from '@liquid-js/qrcode-generator/lib/text/stringToBytes_SJIS.js'

export const stringToBytesFuncs = stringToBytes_SJIS
